import React, { useState } from "react";

function ChangePassword({ user }) {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleChangePassword = (e) => {
    e.preventDefault();

    if (!user?.email) {
      setStatus({ type: "error", message: "User email not available." });
      return;
    }

    if (newPassword !== confirmPassword) {
      setStatus({ type: "error", message: "Passwords do not match." });
      return;
    }

    setLoading(true);

    fetch("https://resumefuel.xyz/resume/src/change_password.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: user.email, // ✅ Pass email explicitly
        new_password: newPassword,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        setLoading(false);
        if (data.success) {
          setStatus({ type: "success", message: "Password updated successfully!" });
          setNewPassword("");
          setConfirmPassword("");
        } else {
          setStatus({ type: "error", message: data.message || "Password change failed." });
        }
      })
      .catch((err) => {
        setLoading(false);
        console.error("Error:", err);
        setStatus({ type: "error", message: "Something went wrong." });
      });
  };

  return (
    <div class="login-txt" style={styles.container}>
      <h2>🔐 Change Password</h2>

      {status && (
        <div
          style={{
            color: status.type === "error" ? "red" : "green",
            marginBottom: "15px",
          }}
        >
          {status.message}
        </div>
      )}

      <form onSubmit={handleChangePassword} style={styles.form}>
        <input
          type="password"
          placeholder="New Password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          required
          style={styles.input}
        />
        <input
          type="password"
          placeholder="Confirm New Password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          required
          style={styles.input}
        />

        <button type="submit" style={styles.button} disabled={loading}>
          {loading ? "Updating..." : "Update Password"}
        </button>
      </form>
    </div>
  );
}

const styles = {
  container: {
    maxWidth: "500px",
    margin: "40px auto",
    padding: "30px",
    border: "1px solid #ccc",
    borderRadius: "8px",
    background: "#fff",
    boxShadow: "0 0 10px rgba(0,0,0,0.1)",
  },
  form: {
    display: "flex",
    flexDirection: "column",
  },
  input: {
    marginBottom: "15px",
    padding: "10px",
    fontSize: "1em",
    border: "1px solid #ccc",
    borderRadius: "4px",
  },
  button: {
    padding: "12px",
    fontSize: "1em",
    backgroundColor: "#28a745",
    color: "#fff",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
  },
};

export default ChangePassword;
